export var EPropertyMemberTypes;
(function (EPropertyMemberTypes) {
    EPropertyMemberTypes["Admin"] = "ADMIN";
    EPropertyMemberTypes["Owner"] = "OWNER";
    EPropertyMemberTypes["Broker"] = "BROKER";
    EPropertyMemberTypes["TaskMember"] = "TASK_MEMBER";
    EPropertyMemberTypes["TechnicalManager"] = "TECHNICAL_MANAGER";
    EPropertyMemberTypes["FinancialManager"] = "FINANCIAL_MANAGER";
    EPropertyMemberTypes["Tenant"] = "TENANT";
    EPropertyMemberTypes["Parent"] = "PARENT";
    // Should not be used in frontend
    EPropertyMemberTypes["Signer"] = "SIGNER";
})(EPropertyMemberTypes || (EPropertyMemberTypes = {}));
export var EPropertyMemberFromString = new Map([
    ["ADMIN", EPropertyMemberTypes.Admin],
    ["OWNER", EPropertyMemberTypes.Owner],
    ["BROKER", EPropertyMemberTypes.Broker],
    ["TASK_MEMBER", EPropertyMemberTypes.TaskMember],
    ["TECHNICAL_MANAGER", EPropertyMemberTypes.TechnicalManager],
    ["FINANCIAL_MANAGER", EPropertyMemberTypes.FinancialManager],
    ["TENANT", EPropertyMemberTypes.Tenant],
    ["PARENT", EPropertyMemberTypes.Parent],
]);
export var EPropertyAdjoined;
(function (EPropertyAdjoined) {
    EPropertyAdjoined["Freestanding"] = "freestanding";
    // cSpell:ignore oneside
    EPropertyAdjoined["OneSide"] = "oneside";
    // cSpell:ignore bothsides
    EPropertyAdjoined["BothSides"] = "bothsides";
    EPropertyAdjoined["Unknown"] = "unknown";
})(EPropertyAdjoined || (EPropertyAdjoined = {}));
/**
 *   Empty line → Store as null
    “No EPC available” → Store as “NA”
    “A+ (kWh/m2<=0)” → Store as “A+”
    “A (0<kWh/m2<=100)” → Store as “A”
    “B (100<kWh/m2<=200)” → Store as “B”
    “C (200<kWh/m2<=300)” → Store as “C”
    “D (300<kWh/m2<=400)” → Store as “D”
    “E (400<kWh/m2<=500)” → Store as “E”
    “F (kWh/m2>500)” → Store as “F”
 */
export var EPropertyEPCLabel;
(function (EPropertyEPCLabel) {
    EPropertyEPCLabel["Unknown"] = "unknown";
    EPropertyEPCLabel["NoEPCAvailable"] = "NA";
    EPropertyEPCLabel["APlus"] = "A+";
    EPropertyEPCLabel["A"] = "A";
    EPropertyEPCLabel["B"] = "B";
    EPropertyEPCLabel["C"] = "C";
    EPropertyEPCLabel["D"] = "D";
    EPropertyEPCLabel["E"] = "E";
    EPropertyEPCLabel["F"] = "F";
})(EPropertyEPCLabel || (EPropertyEPCLabel = {}));
export var EElectricityType;
(function (EElectricityType) {
    EElectricityType["Single"] = "single";
    EElectricityType["Double"] = "double";
    EElectricityType["Unknown"] = "unknown";
})(EElectricityType || (EElectricityType = {}));
export var EElectricityMeterType;
(function (EElectricityMeterType) {
    EElectricityMeterType["Standard"] = "standard";
    EElectricityMeterType["Opening"] = "opening";
    EElectricityMeterType["Budget"] = "budget";
    EElectricityMeterType["Empty"] = "empty";
})(EElectricityMeterType || (EElectricityMeterType = {}));
export var ENaturalGasAvailable;
(function (ENaturalGasAvailable) {
    ENaturalGasAvailable["Available"] = "available";
    ENaturalGasAvailable["Unavailable"] = "unavailable";
    ENaturalGasAvailable["Unknown"] = "unknown";
})(ENaturalGasAvailable || (ENaturalGasAvailable = {}));
export var ENaturalGasMeterType;
(function (ENaturalGasMeterType) {
    ENaturalGasMeterType["Standard"] = "standard";
    ENaturalGasMeterType["Opening"] = "opening";
    ENaturalGasMeterType["Budget"] = "budget";
    ENaturalGasMeterType["Empty"] = "empty";
})(ENaturalGasMeterType || (ENaturalGasMeterType = {}));
export var EPropertyTypes;
(function (EPropertyTypes) {
    EPropertyTypes["Group"] = "group";
    EPropertyTypes["Building"] = "building";
    EPropertyTypes["House"] = "home";
    EPropertyTypes["Apartment"] = "apartment";
    EPropertyTypes["StudentResidence"] = "student_residence";
    EPropertyTypes["Commercial"] = "commercial";
    EPropertyTypes["ParkingLot"] = "parking_lot";
    EPropertyTypes["Garage"] = "garage";
    EPropertyTypes["Office"] = "office";
    EPropertyTypes["Warehouse"] = "warehouse";
    EPropertyTypes["Shed"] = "shed";
    EPropertyTypes["Storage"] = "storage";
    EPropertyTypes["Other"] = "other";
})(EPropertyTypes || (EPropertyTypes = {}));
